module.exports = __webpack_public_path__ + "createstatic/media/linesonthreejs.58620a23.png";